import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({
            autoRaf: true,
            anchors: true,
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        });
        window.__lenis = lenis;
        return () => {
            lenis.destroy();
            delete window.__lenis;
        };
    }, []);
    return null;
}
